/* Keep proof links aligned when upstream app content expands after a click.
 * Progressive enhancement only: native anchors remain usable without this file.
 * Correction is bounded and stops immediately on the customer's next input.
 */
(() => {
  if (window.__leveeProofNavigationBound) return;
  window.__leveeProofNavigationBound = true;
  let cancelActive;
  const selector = '.lv-proof-cue[href="#levee-podiatrist"], .lv-back-to-size[href="#levee-choose-size"]';

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.(selector);
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    cancelActive?.();
    event.preventDefault();
    if (location.hash !== link.hash) history.pushState(null, '', link.hash);

    let stopped = false;
    let frame;
    let timer;
    let observer;
    const events = ['wheel', 'touchstart', 'pointerdown', 'keydown', 'popstate', 'pagehide'];
    const stop = () => {
      if (stopped) return;
      stopped = true;
      cancelAnimationFrame(frame);
      clearTimeout(timer);
      observer?.disconnect();
      events.forEach((name) => window.removeEventListener(name, stop, true));
      if (cancelActive === stop) cancelActive = null;
    };
    // One click-scoped clock: resize/font callbacks share this path, never restart it.
    const startedAt = performance.now();
    const startTop = window.scrollY;
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    let animating = !reducedMotion;
    const align = () => {
      if (stopped) return;
      if (!target.isConnected) return stop();
      const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      const destination = Math.max(0, target.getBoundingClientRect().top + window.scrollY - margin);
      const progress = Math.min(1, (performance.now() - startedAt) / 400);
      const eased = progress < 0.5 ? 4 * progress ** 3 : 1 - (-2 * progress + 2) ** 3 / 2;
      const top = animating ? startTop + (destination - startTop) * eased : destination;
      // Explicit instant steps prevent CSS scroll-behavior from starting a second animation.
      if (Math.abs(window.scrollY - top) > 1) window.scrollTo({ top, behavior: 'instant' });
      animating = animating && progress < 1;
      if (animating) frame = requestAnimationFrame(align);
    };
    const schedule = () => {
      if (stopped) return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(align);
    };
    if (typeof ResizeObserver === 'function') {
      observer = new ResizeObserver(schedule);
      observer.observe(document.body);
      const section = target.closest('.shopify-section');
      if (section) {
        observer.observe(section);
        if (section.previousElementSibling) observer.observe(section.previousElementSibling);
      }
    }
    events.forEach((name) => window.addEventListener(name, stop, { capture: true, passive: true }));
    cancelActive = stop;
    timer = setTimeout(stop, 5000);
    target.focus({ preventScroll: true });
    document.fonts?.ready.then(schedule);
    schedule();
  });
})();
